/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBrandOnboardingStatusRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetBrandOnboardingStatusResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getBrandOnboardingStatus = (request: GetBrandOnboardingStatusRequest, options?: CashRequestOptions) => post<GetBrandOnboardingStatusRequest, GetBrandOnboardingStatusResponse>("/2.0/cash/get-brand-onboarding-status", request, {...options, rejectOnError: true })